const dehestanD = [
  "0403050001",
  "0312010003",
  "0405020002",
  "0405020003",
  "0405010005",
  "0405010002",
  "0405020001",
  "0405010007",
  "0314030001",
  "0401030002",
  "0401030003",
  "0405010006",
  "0401010002",
  "0401010001",
  "0403020004",
  "0322010002",
  "0401020002",
  "0401020001",
  "0401030001",
  "0401050002",
  "0401040008",
  "0401040011",
  "0401050003",
  "0401050001",
  "0401040004",
  "0401040005",
  "0401040006",
  "0401040002",
  "0401040001",
  "0401040003",
  "0401020003",
  "0314030002",
  "0314020005",
  "0314020003",
  "0322010001",
  "0321010001",
  "0321030002",
  "0321010002",
  "0321020001",
  "0321030001",
  "0325020002",
  "0325020001",
  "0408040003",
  "0408030007",
  "0409030001",
  "0409030002",
  "0401040007",
  "0413010002",
  "0413020002",
  "0402020002",
  "0402020001",
  "0413020001",
  "0413010001",
  "0407020004",
  "0407020002",
  "0408030006",
  "0407020001",
  "0407010002",
  "0402010004",
  "0407010001",
  "0404010004",
  "1201030002",
  "0410020003",
  "1203020001",
  "1203020002",
  "1203020006",
  "1201020001",
  "1201040001",
  "1203030002",
  "1203030001",
  "1206020002",
  "1207020001",
  "1207030002",
  "1203010003",
  "1207010002",
  "1203010002",
  "1203010001",
  "1203010005",
  "1203020003",
  "0410020004",
  "0410010001",
  "0410020001",
  "0410020002",
  "0410010002",
  "0408030002",
  "0408030005",
  "0408030004",
  "0408040002",
  "0320020003",
  "0320020002",
  "0312010001",
  "0314020002",
  "0314010003",
  "0307020006",
  "0314010001",
  "0307020001",
  "0314010002",
  "0303030001",
  "0303040001",
  "0303040002",
  "0412010002",
  "0412010001",
  "0412020003",
  "1909010001",
  "1207010001",
  "0412010003",
  "1203010004",
  "0412020001",
  "0412020002",
  "0411010003",
  "0411010001",
  "0410010003",
  "0411010002",
  "0411020003",
  "0408050002",
  "0323020001",
  "0323020003",
  "0311030003",
  "0306030003",
  "0408050003",
  "0411020004",
  "0408050001",
  "0320010002",
  "0320010001",
  "0408030003",
  "0306030002",
  "0306030001",
  "0320020001",
  "0306020003",
  "0306020005",
  "0306020004",
  "0312010002",
  "0325010002",
  "0305010005",
  "0305010006",
  "0305010004",
  "0305020002",
  "0305010002",
  "0305010003",
  "0305010001",
  "0305020003",
  "0305020001",
  "0316020002",
  "2404020006",
  "2404020002",
  "0316010001",
  "0316020001",
  "0316020003",
  "0313020005",
  "0313010004",
  "0313010001",
  "0313020001",
  "0313020004",
  "0313020003",
  "0324020001",
  "0302020005",
  "0324020004",
  "0303030002",
  "0316010002",
  "0316010003",
  "0313020002",
  "0303030005",
  "0303030006",
  "0322020002",
  "0322020001",
  "0322020003",
  "0321030004",
];
// const cityD = [
//   "0401032404",
//   "0401041235",
//   "0322011205",
//   "0409021254",
//   "0306021223",
//   "0407021248",
//   "0410021247",
//   "1203021456",
//   "0413011252",
//   "0413022408",
//   "0409031253",
//   "0410012548",
//   "0408031251",
//   "0320012296",
//   "0411022407",
//   "0411011250",
//   "0411012591",
//   "0408052592",
//   "0401052151",
//   "0303041206",
//   "0303031214",
//   "0405011242",
//   "0314022101",
//   "0314022544",
//   "0305011220",
//   "0316021217",
//   "0316022230",
//   "0316022333",
//   "0316022147",
//   "0305021216",
//   "0305022399",
//   "0305022330",
//   "0313021207",
//   "0316012146",
//   "0303031213",
//   "0314011212",
//   "0314022148",
//   "0314022149",
//   "0314021210",
//   "0314021209",
//   "0314021211",
//   "0314031208",
//   "0322021204",
//   "0321021203",
//   "0303031215",
//   "0321031201",
//   "0321011202",
//   "0401022403",
//   "0325021222",
//   "0312011221",
//   "0320021224",
//   "0408042232",
//   "1203012502",
// ];

const mahdudeD = [
  "Salmas",
  "Sarv",
  "Tasooj",
  "Urmia",
  "Silvana",
  "Ziveh",
  "Oshnavieh",
  "Naghadeh",
  "Mahabad",
  "Bookan",
  "Saghez",
  "Takab",
  "Saeen Ghale",
  "Miandoab",
  "Maragheh",
  "Ajab shir",
  "Shiramin",
  "Azarshahr",
  "Tabriz",
  "Sofian-Shabestar",
  "Bostan abad",
  "Bilverdi-Doozdoozan",
  "Sarab",
  // '',
  // '',
  // '',
];

const subbasinD = [
  "Zola Chay",
  "Khorkhore Chay",
  "Lake",
  "Kahriz",
  "Nazlu Chay",
  "Rozeh Chay",
  "Shahr Chay",
  "Barandouz Chay",
  "Nari",
  "Gadar Chay",
  "Mahabad Chay",
  "Simineh rud",
  "Zarineh rud",
  "Leylan Chay",
  "Mardogh Chay",
  "Sufi Chay",
  "Joan Chay",
  "Ghale Chay",
  "Shiramin",
  "Azarshahr Chay",
  "Islands",
  "Northern rivers (West)",
  "Northern rivers (East)",
  "Aji Chay",
  // '',
  // '',
  // '',
];

const AquiferD = [
  "سراب",
  "مهربان",
  "بستان آباد1",
  "بستان آباد",
  "بيلوردي - دوزدوزان",
  "بخشايش",
  "باسمنج",
  "تبريز",
  "صوفيان-شبستر",
  "تسوج",
  "قالقاچي",
  "سلماس",
  "ممكان",
  "هورسين",
  "سرو",
  "اروميه",
  "منصور آباد",
  "اشنويه",
  "(نقده (مياندوآب 3",
  "(مهاباد‌(مياندوآب 2",
  "بوكان",
  "صايين قلعه",
  "مياندوآب",
  "بناب",
  "عجب شير",
  "(شيرامين (آذرشهر",
  "آذرشهر",
];

const getRandomColor = () => {
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const createLayerColor = (array) => {
  const the = [];

  array.forEach((e) => {
    the.push(e);
    the.push(getRandomColor());
  });

  the.push(getRandomColor());
  return the;
};

const subbasin = {
  name: "زیرحوضه های حوضه آبریز دریاچه ارومیه",
  source: {
    id: "subbasin-source",
    url: "mapbox://martinroosta.d374kkpq",
    type: "vector",
  },
  layer: {
    id: "subbasin-layer",
    type: "fill",
    "source-layer": "subbasin-9nm7om",
    source: "subbasin-source",
    paint: {
      "fill-color": [
        "match",
        ["get", "Basin_En"],
        ...createLayerColor(subbasinD),
      ],
      "fill-opacity": 0.7,
      "fill-outline-color": "#333",
    },
  },
};

const mahdude = {
  name: "محدوده مطالعاتی حوضه آبریز دریاچه ارومیه",
  source: {
    id: "mahdude-source",
    url: "mapbox://martinroosta.6s67w0o0",
    type: "vector",
  },
  layer: {
    id: "mahdude-layer",
    type: "fill",
    "source-layer": "mahdude-1n5oe8",
    source: "mahdude-source",
    paint: {
      "fill-color": [
        "match",
        ["get", "Area_en"],
        ...createLayerColor(mahdudeD),
      ],
      "fill-opacity": 0.7,
      "fill-outline-color": "#333",
    },
  },
};

const village = {
  name: "جمعیت روستایی حوضه آبریز دریاچه ارومیه بر اساس نقاط سرشماری سال 1395",
  source: {
    id: "village-source",
    url: "mapbox://martinroosta.bw0yf5gv",
    type: "vector",
  },
  layer: {
    id: "village-layer",
    type: "heatmap",
    "source-layer": "village_pop95-12armk",
    source: "village-source",
    paint: {
      "heatmap-opacity": 0.7,
      "heatmap-radius": 7,
    },
  },
};

const Aquifer = {
  name: "آبخوان های حوضه آبریز دریاچه ارومیه",
  source: {
    id: "Aquifer-source",
    url: "mapbox://martinroosta.0iie1w4t",
    type: "vector",
  },
  layer: {
    id: "Aquifer-layer",
    type: "fill",
    "source-layer": "Aquifer-6qn8av",
    source: "Aquifer-source",
    paint: {
      "fill-color": [
        "match",
        ["get", "bilan_name"],
        ...createLayerColor(AquiferD),
      ],
      "fill-opacity": 0.85,
      "fill-outline-color": "#333",
    },
  },
};

const Urmia = {
  name: "مرز حوضه آبریز دریاچه ارومیه",
  source: {
    id: "Urmia-source",
    url: "mapbox://martinroosta.96fnvh3p",
    type: "vector",
  },
  layer: {
    id: "Urmia-layer",
    type: "line",
    "source-layer": "Urmia_Lake_Basin-dlgx0d",
    source: "Urmia-source",
    paint: {
      // 'fill-color': ['match', ['get', 'Name_En'], 'Urmia Lake Basin', getRandomColor(), getRandomColor()],
      // 'fill-opacity': 0.7,
      // 'fill-outline-color': '#333',
      "line-blur": 1,
      "line-color": getRandomColor(),
      // 'line-color': '#de5246',
      "line-width": 3,
      // 'line-offset': 2,
      // 'line-cap': 'round',
    },
  },
};
const City = {
  name: "محدوده شهرها",
  source: {
    id: "City-source",
    url: "mapbox://martinroosta.6d1k4aez",
    type: "vector",
  },
  layer: {
    id: "City-layer",
    type: "fill",
    "source-layer": "City_pop95_2-2kpzpj",
    source: "City-source",
    paint: {
      "fill-color": "#1A2F38",
      "fill-opacity": 0.90,
      "fill-outline-color": "#e63946",
    },
    // paint: {
    //   // 'fill-color': ['match', ['get', 'Name_En'], 'Urmia Lake Basin', getRandomColor(), getRandomColor()],
    //   "fill-opacity": 1,
    //   "fill-color": "#125",
    //   // "line-blur": 1,
    //   // "line-color": getRandomColor(),
    //   // 'line-color': '#de5246',
    //   // "line-width": 3,
    //   // 'line-offset': 2,
    //   // 'line-cap': 'round',
    // },
  },
};
const Dasht = {
  name: "محدوده دشت ها",
  source: {
    id: "Dasht-source",
    url: "mapbox://martinroosta.d3c83ajo",
    type: "vector",
  },
  layer: {
    id: "Dasht-layer",
    type: "fill",
    "source-layer": "Mahdoodeh_dasht-atxdjm",
    source: "Dasht-source",
    paint: {
      // 'fill-color': ['match', ['get', 'Name_En'], 'Urmia Lake Basin', getRandomColor(), getRandomColor()],
      "fill-opacity": 0.7,
      "fill-outline-color": "#125",
      // "line-blur": 1,
      // "line-color": getRandomColor(),
      // 'line-color': '#de5246',
      // "line-width": 3,
      // 'line-offset': 2,
      // 'line-cap': 'round',
    },
  },
};
const Wells = {
  name: "موقعیت چاه ها",
  source: {
    id: "Wells-source",
    url: "mapbox://martinroosta.555m9gvg",
    type: "vector",
  },
  layer: {
    id: "Wells-layer",
    type: "heatmap",
    "source-layer": "wells_locations-2wqnot",
    source: "Wells-source",
    paint: {
      "heatmap-opacity": 0.7,
      "heatmap-radius": 7,
      // 'fill-color': ['match', ['get', 'Name_En'], 'Urmia Lake Basin', getRandomColor(), getRandomColor()],
      // "fill-opacity": 0.7,
      // "fill-outline-color": "#125",
      // "line-blur": 1,
      // "line-color": getRandomColor(),
      // 'line-color': '#de5246',
      // "line-width": 3,
      // 'line-offset': 2,
      // 'line-cap': 'round',
    },
  },
};
const Dehestan = {
  name: "موقعیت دهستان ها",
  source: {
    id: "dehestan-source",
    url: "mapbox://martinroosta.9zizdvj7",
    type: "vector",
  },
  layer: {
    id: "dehestan-layer",
    type: "fill",
    "source-layer": "dehestan-cc82oq",
    source: "dehestan-source",
    paint: {
      // "heatmap-opacity": 0.7,
      // "heatmap-radius": 7,
      "fill-color": [
        "match",
        ["get", "Field20"],
        ...createLayerColor(dehestanD),
      ],
      "fill-opacity": 0.7,
      "fill-outline-color": "#125",
      // "line-blur": 1,
      // "line-color": getRandomColor(),
      // 'line-color': '#de5246',
      // "line-width": 3,
      // 'line-offset': 2,
      // 'line-cap': 'round',
    },
  },
};

const exp = [
  mahdude,
  subbasin,
  village,
  Aquifer,
  Urmia,
  City,
  Dasht,
  Wells,
  Dehestan,
];
export default exp;
